import { BuildingOffice2Icon } from '@heroicons/react/24/outline';
import { HomeIcon } from '@heroicons/react/24/solid';
import React from 'react';

import KPICard from '../../../common/KPICards';
import type { CompanyInfoBlockProps } from './types';

/** Lots managed according to the national register (RNIC), not to what the company entered. */
export default function CompanyLotsCards({ details, loading }: CompanyInfoBlockProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <KPICard
        icon={<HomeIcon className="h-6 w-6" />}
        title="Lots d'habitation"
        value={details?.nbLotsHab || '0'}
        loading={loading}
      />
      <KPICard
        icon={<BuildingOffice2Icon className="h-6 w-6" />}
        title="Lots totaux (hab., bureaux, commerces)"
        value={details?.nbLotsHabBurCom || '0'}
        loading={loading}
      />
    </div>
  );
}
